import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

interface ConfirmationModalProps {
    show: boolean;
    title: string;
    message: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ show, title, message, onClose, onConfirm }) => (
    <Dialog open={show} onClose={onClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
            <Button variant="contained" onClick={onClose}>
                בטל
            </Button>
            <Button variant="contained" color="error" onClick={onConfirm}>
                אשר
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmationModal;
